import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const img = (u) => (u && u.charAt(0) === "/" ? API + u : u || "");

// Public hosted pop-up calendar: /s/:slug/popups  (deep-link + iframe target).
// ?embed=1 renders chrome-less for the embedded iframe.
export default function PopupsPage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const embed = params.get("embed") === "1";
  const [tenant, setTenant] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!slug) return;
    axios.get(`${API}/api/public/tenant/${slug}`).then((r) => { setTenant(r.data); setStatus(r.data?.widgets?.popups === false ? "off" : "on"); }).catch(() => setStatus("off"));
  }, [slug]);

  useEffect(() => {
    if (status !== "on") return;
    document.title = `Find us · ${tenant?.name || slug}`;
    const s = document.createElement("script");
    s.id = "morrcart-embed";
    s.src = `${API}/embed.js`;
    s.setAttribute("data-tenant", slug);
    s.setAttribute("data-morrcart-context", "hosted");
    document.body.appendChild(s);
    return () => {
      s.remove();
      document.querySelectorAll("[data-morrcart]").forEach((n) => n.remove());
      window.__morrcartLoaded = undefined;
      window.MorrCart = undefined;
    };
  }, [status, slug, tenant]);

  const shell = (children) => (
    <div style={{ minHeight: "100vh", background: embed ? "transparent" : "#faf8f5", color: "#111", fontFamily: "system-ui,-apple-system,sans-serif", padding: embed ? 16 : "48px 24px" }}>
      <div style={{ maxWidth: 820, width: "100%", margin: "0 auto" }} data-testid="popups-page">{children}</div>
    </div>
  );

  if (status === "loading") return shell(<p style={{ color: "#888", textAlign: "center" }}>Loading…</p>);
  if (status === "off") return shell(
    <div style={{ textAlign: "center", paddingTop: 40 }}>
      <h1 style={{ fontSize: 24, marginBottom: 8 }}>Store not found</h1>
      <p style={{ color: "#777" }}>Please check the link and try again.</p>
    </div>
  );

  return shell(
    <div>
      {!embed && (
        <header style={{ textAlign: "center", marginBottom: 32 }}>
          {tenant?.logo_url && <img src={img(tenant.logo_url)} alt="" style={{ height: 48, width: 48, objectFit: "contain", borderRadius: 10, marginBottom: 14 }} />}
          <h1 style={{ fontSize: 32, marginBottom: 6, fontWeight: 800 }}>Where to find us</h1>
          <p style={{ color: "#777", fontSize: 16 }}>Our upcoming pop-ups &amp; stops — tap a date for details.</p>
        </header>
      )}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div data-morrcart-popup-calendar style={{ width: "100%" }} />
      </div>
    </div>
  );
}
